export const COLORS = {
  textMain: '#292929',
  white: '#FFFFFF',
  white2: '#FCFEFF',

  grey100: '#F9F9F9',
  grey150: '#EEEEEE',
  grey200: '#DDDDDD',
  grey250: '#c7c7c7',
  grey300: '#C9C8C8',
  grey300Opacity30: 'rgba(201, 200, 200, 0.3)',
  grey350: '#989898',
  grey400: '#6D6D6D',
  grey500: '#F1F1F1',
  grey600: '#D2D5DA',
  grey700: '#f2f2f2',

  blue50: '#E6F3FD',
  blue75: '#d4e7f6',
  blue100: '#A2D3F7',
  blue200: '#55B2F6',
  blue300: '#46A4E8',
  blue350: '#4193CE',
  blue600: '#0487E6',
  blue800: '#0060A6',

  error: '#B3261E',
  errorDark: '#C62828',
  primary: '#2196F3',
  redBg: '#FDE9E6',

  greenMain: '#39B75F',
  green100: '#E5FFEC',

  purple: '#5356FF',
  darkPurple: '#323499',
  purpleBG: 'rgba(83, 86, 225, 0.1)',
  lightBlue: '#378CE7',
  darkBlue: '#014361',
  darkBlue2: '#272E5B',
  black: '#000000',
  black01: 'rgba(0, 0, 0, 0.1)',
  black012: 'rgba(0, 0, 0, 0.12)',
  black02: 'rgba(0, 0, 0, 0.2)',
  black03: 'rgba(0, 0, 0, 0.3)',
  black038: 'rgba(0, 0, 0, 0.38)',
  black04: 'rgba(0, 0, 0, 0.4)',
  black06: 'rgba(0, 0, 0, 0.6)',
  black08: 'rgba(0, 0, 0, 0.87)',
  pink: '#D500F9',
  textMainOpacity15: 'rgba(41, 41, 41, 0.15)',
  disableGrayColor: 'gray',
  lightGray: '#FAFAFA',
  lightGray2: '#0000001F',
  lightBlue01: 'rgba(55, 140, 231, 0.1)',
  lightBlue07: 'rgba(55, 140, 231, 0.7)',
  green: '#4CAF50',
  green2: '#28C156',
  darkGreen: '#2E7D32',
  lightGreenBg: '#F0FBF3',
  orange: '#EF6C00',
  orange2: '#FF8F44',
  orange2Opacity40: 'rgba(255, 143, 68, 0.4)',
  blue: '#378CE7',
  dark: '#1A2027',
  primaryGray: '#F5F5F5',
  flowerBlue: '#67C6E3',
  red: 'red',
  darkRed: '#D32F2F',
  blackShadow: '#44444d81',
  gray005: 'rgba(0, 0, 0, 0.05)',
  gray01: 'rgba(0, 0, 0, 0.1)',
  gray02: 'rgba(0, 0, 0, 0.2)',
  gray04: 'rgba(0, 0, 0, 0.4)',
  gray06: 'rgba(0, 0, 0, 0.6)',
  grayError: 'rgb(229, 231, 239)',
  graphSecond: '#9C27B0',
  disabled: '#9E9E9E',
  bgGray: '#F7F7F7',
  grayE0: '#E0E0E0',
  yellow: '#F5D60E',
  transparent: 'transparent',
} as const;
